<form [formGroup]="form" (ngSubmit)="onSave()">
  <div class="formgrid grid">

  <div class="col-5">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Name</h3>
    <input pInputText formControlName="name" type="text" class="inputfield w-full"
      (input)="onNameInput()"
      [ngClass]="{ 'ng-invalid ng-dirty': form.get('name')?.invalid && form.get('name')?.touched }"
      placeholder="Sydney" />
  </div>

  <div class="col-3">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Slug</h3>
    <input pInputText formControlName="slug" type="text" class="inputfield w-full"
      [readonly]="slugIsReadOnly"
      [ngClass]="{ 'ng-invalid ng-dirty': form.get('slug')?.invalid && form.get('slug')?.touched, 'surface-100': slugIsReadOnly }"
      placeholder="sydney" />
    <small class="block text-500 mt-1">
      <a class="cursor-pointer text-primary font-medium" (click)="toggleSlugEdit()">{{ slugIsReadOnly ? 'Edit manually' : 'Auto from name' }}</a>
    </small>
  </div>

  <div class="col-2">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">State</h3>
    <p-dropdown formControlName="state" [options]="states" styleClass="w-full" appendTo="body"></p-dropdown>
  </div>

  <div class="col-2">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Order</h3>
    <input pInputText formControlName="order" type="number" class="inputfield w-full" />
  </div>

  <div class="col-6">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Short description</h3>
    <textarea pInputTextarea formControlName="intro" rows="2" class="inputfield w-full"
      placeholder="One or two plain sentences."></textarea>
    <small class="block text-500 mt-1">The region's card blurb around the site (and the hero lead).</small>
  </div>

  <div class="col-6">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">SEO description <span class="text-500 text-sm font-normal">(optional)</span></h3>
    <textarea pInputTextarea formControlName="seoDescription" rows="2" class="inputfield w-full"
      placeholder="Blank = the short description is used."></textarea>
    <small class="block text-500 mt-1">Shown under the page's title in Google (~155 chars).</small>
  </div>

  <div class="col-12"><hr class="border-200" /></div>

  <!-- ── The page itself: hero + building blocks ── -->
  <div class="col-12">
    <div class="border-bottom-1 border-200">
      <h3 class="text-500 my-2">Page — hero &amp; building blocks</h3>
    </div>
    <small class="block text-500 mb-3">
      This IS the region's page on picaluna.com. The listing blocks (Suburbs in a region, Venues in
      an area, Funeral directors grid…) fill themselves with this region's own data. With no
      sections at all, the site falls back to its automatic region layout.
    </small>
    <!-- The preview (#263): the block being edited, drawn by the website's own components, in a sticky column. -->
    <div class="flex gap-3 align-items-start">
      <app-content-sections-editor class="flex-1 min-w-0"></app-content-sections-editor>
      <app-block-preview *ngIf="preview.shown && !stage" [source]="previewSource" (closed)="preview.set(false)"></app-block-preview>
    </div>
  </div>

  <!-- Sticky action bar — same shape as the Pages editor's, so the two feel
       like one tool. bottom offset swallows the dialog content's own padding. -->
  <div class="col-12 flex align-items-center justify-content-between gap-2 surface-card border-top-1 border-200 py-3"
       style="position: sticky; bottom: -1.5rem; z-index: 5; margin-bottom: -1.5rem">
    <div class="flex gap-2">
      <span [pTooltip]="sectionsEditor.hasHero ? 'This page already has its hero — a page has exactly one, because it renders the page headline.' : ''"
        tooltipPosition="top">
        <button pButton pRipple type="button" label="Add hero" icon="pi pi-image"
          class="p-button-outlined p-button-sm" [disabled]="sectionsEditor.hasHero"
          (click)="sectionsEditor.addSection('editorial-hero')"></button>
      </span>
      <button pButton pRipple type="button" label="Add section" icon="pi pi-plus"
        class="p-button-outlined p-button-sm" (click)="sectionsEditor.addSection('section')"></button>
      <app-block-preview-toggle></app-block-preview-toggle>
    </div>
    <div class="flex align-items-center gap-4">
      <span class="flex align-items-center"
        pTooltip="Shown on picaluna.com — the region AND its page publish together." tooltipPosition="top">
        <p-inputSwitch class="flex-initial" formControlName="published"></p-inputSwitch>
        <span class="ml-2 text-700">Published</span>
      </span>
      <span class="flex gap-2">
        <button pButton pRipple type="button" label="Cancel" class="p-button-text" [disabled]="saving" (click)="onCancel()"></button>
        <button pButton pRipple type="submit" label="Save" icon="pi pi-check" [loading]="saving"></button>
      </span>
    </div>
  </div>

  </div>
</form>
